import React, { useEffect } from 'react';
import Constants from 'src/helper/Constants';
import System from 'src/helper/system';
import { profileStore } from 'src/hooks/profile';
import useReduxState from 'src/hooks/useReduxState';

const ContactPopup = (props) => {
    const { SetStatus, data: { isFromManualCart } } = props;
    const { translation: t } = System;
    const [, setProductSelected] = useReduxState({}, 'setAutoCompleteProductSelected')
    const [, setSearchTerm] = useReduxState('', 'setAutoCompleteSearchTerm')
    const [{ profile_account_information }, { get_profile_account_information }, { }] = profileStore();
    const {
        siteUser: { CORE, WEB },
        speedBoats: { apacAbbr },
    } = Constants;

    useEffect(() => {
        async function fetchHere() {
            await get_profile_account_information()
        }

        if (profile_account_information && Object.keys(profile_account_information)?.length === 0 && System.getCurrentRegionWithType(apacAbbr, CORE)) {
            fetchHere()
        }
    }, [])

    return (
        <>
            <div className="avnet-modal share-modal">
                <div className="avnet-modal-inner">
                    {/* Modal Header */}
                    <button type="button" className="close py-3"
                        onClick={() => {
                            SetStatus(false)
                            if (isFromManualCart) {
                                setProductSelected({})
                                setSearchTerm('')
                                setTimeout(() => {
                                    document.body.style.overflow = '';
                                }, 400)
                            }
                        }}
                    >×
                    </button>
                    <div className="modal-header justify-content-center mt-0">
                        <h3 className="pcn-modal-heading pl-5 text-darkgreen">{t('generalSupport')}</h3>
                    </div>
                    {/* Modal body */}
                    <div className="modal-body">
                        <div className="clearfix" />
                        <div className="mt-3 mb-2">
                            {(System.getCurrentRegionWithType(apacAbbr, CORE) && (profile_account_information?.contacts?.some(ele => ele.title === Constants.SALES_PERSON))) ? (
                                <>
                                    <p className='mb-4 font-arial'><strong>{t('contactLocalSales')}.</strong> </p>
                                    <p className='mb-0 font-arial'>{t('salesRepName')} : <strong>{profile_account_information?.contacts?.find(ele => ele.title === Constants.SALES_PERSON)?.contactName}</strong> </p>
                                    <p className='mb-0 font-arial'>{t('phoneNumber')} : <strong>{profile_account_information?.contacts?.find(ele => ele.title === Constants.SALES_PERSON)?.contactNumber}</strong> </p>
                                    <p className='mb-0 font-arial'>{t('emailId')} : <strong><a href={'mailTo:' + profile_account_information?.contacts?.find(ele => ele.title === Constants.SALES_PERSON)?.email}>{profile_account_information?.contacts?.find(ele => ele.title === Constants.SALES_PERSON)?.email}</a></strong> </p>
                                </>
                            ) :
                                <>
                                    <p className='mb-4 font-arial'><strong>{t('contactOnlineSupport')}.</strong> </p>
                                    {System.getCurrentRegionWithType(apacAbbr) && <p className='mb-0 font-arial'>{t('phoneNumber')} : <strong>86 755 2184 5922</strong> </p>}
                                    <p className='mb-0 font-arial'>{t('emailId')} : <strong>{System.getCurrentRegionWithType(apacAbbr) ? <a href="mailto:OnlineSupport-Asia@avnet.com">OnlineSupport-Asia@avnet.com</a> : <a href="mailto:OnlineSupport-Japan@avnet.com">OnlineSupport-Japan@avnet.com</a>}</strong> </p>
                                </>
                            }
                        </div>
                    </div>
                    {/* Modal footer */}
                    <div className="modal-footer text-center">
                        <div className="modal-footer-actions">
                            <button type="button" className="bs5 btn btn-secondary btn-sm minw140"
                                onClick={() => {
                                    SetStatus(false)
                                    if (isFromManualCart) {
                                        setProductSelected({})
                                        setSearchTerm('')
                                        setTimeout(() => {
                                            document.body.style.overflow = '';
                                        }, 400)
                                    }
                                }}
                            >
                                {t('close')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ContactPopup;